export default {
  install: function (Vue) {
    Vue.prototype.$carrot = { track, identify, auth }

    const env = process.env.APP_ENV?.trim()
    const canLog = env === 'dev' || env === 'preprod'
    const reserved = {
      name: '$name',
      email: '$email',
      phone: '$phone',
    }

    async function track (event, data = {}) {
      if (!event) return

      await waitForScript()

      const options = Object.keys(data).reduce((acc, curr) => {
        const value = data[curr]

        if (!value || typeof value === 'object') return acc

        const key = reserved[curr] || curr

        return { ...acc, [key]: value }
      }, {})

      Object.keys(options).length > 0
        ? window.carrotquest.track(event, options)
        : window.carrotquest.track(event)

      if (canLog) console.warn('[carrot_track] ', event, options, data)
    }
    async function identify (data = {}) {
      if (Object.keys(data).length === 0) return

      await waitForScript()

      let options = []

      Object.keys(data).forEach((fieldName) => {
        const key = reserved[fieldName]
        const value = data[fieldName]

        if (key && value) options.push({ op: 'update_or_create', key, value })
      })

      if (Object.keys(options).length > 0) {
        window.carrotquest.identify(options)

        if (canLog) console.warn('[carrot_identify] ', options, data)
      }
    }
    async function auth (id, hash) {
      if (!id || !hash) return

      await waitForScript()

      window.carrotquest.auth(id, hash)

      if (canLog) console.warn('[carrot_auth]', id, hash)
    }
    function waitForScript () {
      const counter = 0

      return new Promise((resolve, reject) => checkIfCarrotExists(resolve, reject, counter))
    }
    function checkIfCarrotExists (resolve, reject, counter) {
      counter++

      if (counter > 10) reject(false) // 5 секунд и 10 попыток уже было, достаточно!

      if (window.carrotquest && window.carrotquest.connected) resolve(true)
      else setTimeout(() => checkIfCarrotExists(resolve, reject, counter), 500)
    }
  }
}
